import { Button, Dialog } from "@mui/material";
import { useEffect, useState } from "react";
import useAuth from "../hooks/useAuth";
import { branchTimezone } from "../../utils/summaryCalculation";
import CustomFormatDatePicker from './CustomFormatDatePicker';
import { useTheme } from "../hooks/useTheme";
import colorConfigs from "../../configs/colorConfigs";
import { getCarsWithReservation } from "../../services/availableCars";
import moment from "moment";
import useConfirm from "../hooks/useConfirm";
import { addExtension } from "../../services/rental";
import useGeneral from "../hooks/useGeneral";
import Cookies from "js-cookie";
import useTenant from "../hooks/useTenant";

type AddExtensionModalProps = {
    addExtensionIsOpen: boolean;
    setAddExtensionIsOpen: (value: boolean) => void;
    summaryData: any
    setExtensionRefresh: (value: boolean) => void;
    locationOpenHourOfParticularBranch: any[];
    formattedCreatedAt: string;
    reservationId: number;
    preferredDateFormat: string;
    setAvailableVehicle: (value: any[]) => void;
    setPleaseWait: (value: boolean) => void;
}

const AddExtensionModal = ({
    addExtensionIsOpen,
    setAddExtensionIsOpen,
    summaryData,
    setExtensionRefresh,
    locationOpenHourOfParticularBranch,
    formattedCreatedAt,
    reservationId,
    preferredDateFormat,
    setAvailableVehicle,
    setPleaseWait
}: AddExtensionModalProps) => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { theme, themeStyles } = useTheme();
    const { auth }: any = useAuth();
    const { handleTenantError }: any = useTenant();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const { dateFormat }: any = useGeneral();
    const [newReturnDate, setNewReturnDate] = useState<string>("");
    const [newReturnTime, setNewReturnTime] = useState<string>("");
    const [comment, setComment] = useState<string>("");
    const [returnDateMessage, setReturnDateMessage] = useState<string>("");

    const UpdateTimezone = branchTimezone(formattedCreatedAt);
    const closeIconFill = theme === "dark" ? "fill-[#E4E7EC]" : "fill-[#1D2939]";

    useEffect(() => {
        if (addExtensionIsOpen) {
            setNewReturnDate(new Date(summaryData?.returnDate).toISOString()?.split("T")[0]);
            setNewReturnTime(summaryData?.returnDate?.split("T")[1])
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [summaryData, addExtensionIsOpen])

    useEffect(() => {
        if (locationOpenHourOfParticularBranch.length !== 0) {
            let returnDateMessages = "";
            if (
                new Date(locationOpenHourOfParticularBranch[0].endDate) >=
                new Date(newReturnDate.replaceAll("-", "/"))
            ) {
                switch (new Date(newReturnDate.replaceAll("-", "/")).getDay()) {
                    case 0:
                        if (locationOpenHourOfParticularBranch[0].isSundayOpen) {
                            returnDateMessages = "";
                            if (
                                locationOpenHourOfParticularBranch[0].sundayOpenTime <=
                                newReturnTime &&
                                locationOpenHourOfParticularBranch[0].sundayCloseTime >=
                                newReturnTime
                            ) {
                                returnDateMessages = "";
                            } else {
                                returnDateMessages =
                                    "Office on Sunday is open from " +
                                    locationOpenHourOfParticularBranch[0].sundayOpenTime +
                                    " to " +
                                    locationOpenHourOfParticularBranch[0].sundayCloseTime;
                            }
                        } else {
                            returnDateMessages = "Office is close on Sunday";
                        }
                        break;
                    case 1:
                        if (locationOpenHourOfParticularBranch[0].isMondayOpen) {
                            returnDateMessages = "";
                            if (
                                locationOpenHourOfParticularBranch[0].mondayOpenTime <=
                                newReturnTime &&
                                locationOpenHourOfParticularBranch[0].mondayCloseTime >=
                                newReturnTime
                            ) {
                                returnDateMessages = "";
                            } else {
                                returnDateMessages =
                                    "Office on Monday is open from " +
                                    locationOpenHourOfParticularBranch[0].mondayOpenTime +
                                    " to " +
                                    locationOpenHourOfParticularBranch[0].mondayCloseTime;
                            }
                        } else {
                            returnDateMessages = "Office is close on Monday";
                        }
                        break;
                    case 2:
                        if (locationOpenHourOfParticularBranch[0].isTuesdayOpen) {
                            returnDateMessages = "";
                            if (
                                locationOpenHourOfParticularBranch[0].tuesdayOpenTime <=
                                newReturnTime &&
                                locationOpenHourOfParticularBranch[0].tuesdayCloseTime >=
                                newReturnTime
                            ) {
                                returnDateMessages = "";
                            } else {
                                returnDateMessages =
                                    "Office on Tuesday is open from " +
                                    locationOpenHourOfParticularBranch[0].tuesdayOpenTime +
                                    " to " +
                                    locationOpenHourOfParticularBranch[0].tuesdayCloseTime;
                            }
                        } else {
                            returnDateMessages = "Office is close on Tuesday";
                        }
                        break;
                    case 3:
                        if (locationOpenHourOfParticularBranch[0].isWednesdayOpen) {
                            returnDateMessages = "";
                            if (
                                locationOpenHourOfParticularBranch[0].wednesdayOpenTime <=
                                newReturnTime &&
                                locationOpenHourOfParticularBranch[0].wednesdayCloseTime >=
                                newReturnTime
                            ) {
                                returnDateMessages = "";
                            } else {
                                returnDateMessages =
                                    "Office on Wednesday is open from " +
                                    locationOpenHourOfParticularBranch[0].wednesdayOpenTime +
                                    " to " +
                                    locationOpenHourOfParticularBranch[0].wednesdayCloseTime;
                            }
                        } else {
                            returnDateMessages = "Office is close on Wednesday";
                        }
                        break;
                    case 4:
                        if (locationOpenHourOfParticularBranch[0].isThursdayOpen) {
                            returnDateMessages = "";
                            if (
                                locationOpenHourOfParticularBranch[0].thursdayOpenTime <=
                                newReturnTime &&
                                locationOpenHourOfParticularBranch[0].thursdayCloseTime >=
                                newReturnTime
                            ) {
                                returnDateMessages = "";
                            } else {
                                returnDateMessages =
                                    "Office on Thursday is open from " +
                                    locationOpenHourOfParticularBranch[0].thursdayOpenTime +
                                    " to " +
                                    locationOpenHourOfParticularBranch[0].thursdayCloseTime;
                            }
                        } else {
                            returnDateMessages = "Office is close on Thursday";
                        }
                        break;
                    case 5:
                        if (locationOpenHourOfParticularBranch[0].isFridayOpen) {
                            returnDateMessages = "";
                            if (
                                locationOpenHourOfParticularBranch[0].fridayOpenTime <=
                                newReturnTime &&
                                locationOpenHourOfParticularBranch[0].fridayCloseTime >=
                                newReturnTime
                            ) {
                                returnDateMessages = "";
                            } else {
                                returnDateMessages =
                                    "Office on Friday is open from " +
                                    locationOpenHourOfParticularBranch[0].fridayOpenTime +
                                    " to " +
                                    locationOpenHourOfParticularBranch[0].fridayCloseTime;
                            }
                        } else {
                            returnDateMessages = "Office is close on Friday";
                        }
                        break;
                    case 6:
                        if (locationOpenHourOfParticularBranch[0].isSaturdayOpen) {
                            returnDateMessages = "";
                            if (
                                locationOpenHourOfParticularBranch[0].saturdayOpenTime <=
                                newReturnTime &&
                                locationOpenHourOfParticularBranch[0].saturdayCloseTime >=
                                newReturnTime
                            ) {
                                returnDateMessages = "";
                            } else {
                                returnDateMessages =
                                    "Office on Saturday is open from " +
                                    locationOpenHourOfParticularBranch[0].saturdayOpenTime +
                                    " to " +
                                    locationOpenHourOfParticularBranch[0].saturdayCloseTime;
                            }
                        } else {
                            returnDateMessages = "Office is close on Saturday";
                        }
                        break;
                }
                if (returnDateMessages !== "") {
                    setReturnDateMessage(returnDateMessages);
                } else {
                    setReturnDateMessage("");
                }
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newReturnDate, newReturnTime])

    const handleSubmit = () => {
        if (new Date(summaryData?.returnDate).getTime() >= new Date(`${newReturnDate}T${newReturnTime}`).getTime()) {
            setReturnDateMessage(
                `New return date can't be same or less than previous return Date`
            );

            return;
        }

        if (new Date(summaryData?.pickupDate).getTime() >= new Date(`${newReturnDate}T${newReturnTime}`).getTime()) {
            setReturnDateMessage(
                `New return date can't be same or less than pickup Date`
            );

            return;
        }

        setPleaseWait(true);

        let latestPickup = moment().format('YYYY-MM-DDTHH:mm');
        let latestReturn = moment().format('YYYY-MM-DDTHH:mm');
        latestPickup = moment(`${summaryData?.returnDate}`).format('YYYY-MM-DDTHH:mm');
        if (newReturnDate) latestReturn = moment(`${newReturnDate}T${newReturnTime}`).format('YYYY-MM-DDTHH:mm');

        getCarsWithReservation(
            reservationId,
            latestPickup,
            latestReturn,
            parseInt(summaryData?.branchId),
            tenantId
        )
            .then(res => {
                handleTenantError(null);
                const vehicleClassId = summaryData?.vehicleClassId;
                const selectedVehicles = res?.find((vehicleClass: any) => vehicleClass?.vehicleClassId === vehicleClassId);

                if (selectedVehicles?.availableVehicles > 0) {
                    setAvailableVehicle(res);
                    updateExtension();
                } else {
                    setConfirmData({
                        title: `Between ${moment(latestPickup)?.format(dateFormat + " hh:mm A")} - ${moment(latestReturn)?.format(dateFormat + " hh:mm A")} dates selected vehicle is not available`,
                        summary: '',
                        confirmBtn: 'Ok',
                        isConfirm: (callback: any) => {
                            callback();
                        }
                    });
                    setConfirmPopup(true);
                    setPleaseWait(false);
                    return;
                }
            })
            .catch((error) => {
                setPleaseWait(false);
                setConfirmData({
                    title: 'Warning',
                    summary: error.response.data,
                    confirmBtn: 'Ok',
                    isConfirm: (callback: any) => {
                        callback();
                    }
                });

                setConfirmPopup(true);
                handleTenantError(error);
                return;
            });
    }

    const updateExtension = () => {
        addExtension(
            {
                reservationId: reservationId,
                oldReturenDate: summaryData?.returnDate,
                newReturenDate: newReturnDate + "T" + newReturnTime,
                comment: comment,
                createdBy: auth?.givenname,
                createdAt: new Date(UpdateTimezone)?.toLocaleString(),
                isExtended: false
            },
            reservationId,
            auth?.id,
            tenantId
        )
            .then(() => {
                setAddExtensionIsOpen(false);
                setExtensionRefresh(true);
                resetTheForm();
                handleTenantError(null);
            })
            .catch(error => {
                setPleaseWait(false);
                handleTenantError(error);
            })
    }

    const resetTheForm = () => {
        setNewReturnDate("");
        setNewReturnTime("");
        setComment("");
        setReturnDateMessage("");
    }


    return (
        <>
            <Dialog
                open={addExtensionIsOpen}
                maxWidth="md"
                fullScreen={false}
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '500px',
                        width: '100%',
                        borderRadius: '16px',
                        overflowY: "unset",
                    },
                }}
            >
                <div className={`px-[15px] py-[15px] h-full ${themeStyles.main.tailwindSectionBg}`}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320.591 320.591"
                        className={`w-3 cursor-pointer float-right ${closeIconFill}`}
                        onClick={() => setAddExtensionIsOpen(false)}
                    >
                        <path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" />
                        <path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" />
                    </svg>
                    <div className={`w-full bg-transparent rounded-lg p-[10px] flex flex-col gap-2.51`}>
                        <div className="w-full mt-2">
                            <div className={`w-full`}>
                                <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                    <div className="flex items-center gap-1.5">
                                        <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Add Extension</h2>
                                    </div>
                                </div>

                                <div className="mt-2 p-2">
                                    <div className="w-full">
                                        <div>
                                            <div className="grid grid-cols-2 gap-6">
                                                <div className="space-y-4">
                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Return Date</label>
                                                        <CustomFormatDatePicker
                                                            value={newReturnDate}
                                                            onChange={setNewReturnDate}
                                                            dateFormat={dateFormat}
                                                            minDate={summaryData?.returnDate
                                                                ? (new Date(summaryData?.returnDate) === undefined ? new Date()?.toISOString()?.split("T")[0] : new Date(summaryData?.returnDate)?.toISOString()?.split("T")[0])
                                                                : ""}
                                                            required={true}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="space-y-4">
                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Return Time</label>
                                                        <input
                                                            type="time"
                                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                            value={newReturnTime}
                                                            onChange={(e) => setNewReturnTime(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <span className="w-full text-sm text-red-500">{returnDateMessage}</span>

                                            <div className="w-full mt-4">
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Comments</label>
                                                <textarea
                                                    className={`w-full px-[8px] py-[8px]  border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    rows={6}
                                                    value={comment}
                                                    onChange={(e) => setComment(e.target.value)}
                                                    required
                                                />
                                            </div>

                                            <div className="mt-4 w-full flex gap-4">
                                                <Button variant="contained"
                                                    sx={{
                                                        backgroundColor: colorConfigs.btn.main.bg
                                                    }}
                                                    onClick={handleSubmit}
                                                >
                                                    Save
                                                </Button>

                                                <Button variant="contained"
                                                    sx={{
                                                        backgroundColor: colorConfigs.btn.cancel.bg,
                                                        border: colorConfigs.btn.cancel.border,
                                                        color: colorConfigs.btn.cancel.color
                                                    }}
                                                    onClick={() => setAddExtensionIsOpen(false)}
                                                >
                                                    Cancel
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default AddExtensionModal;